import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';

const VerifyEmail = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const token = searchParams.get('token');

    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const verifyEmail = async () => {
            try {
                const response = await fetch('https://3nrqnhje08.execute-api.us-east-2.amazonaws.com/api/Users/verifyEmail/confirm', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        token
                    })
                });

                console.log(token);

                if (!response.ok) {
                    const errorData = await response.json();
                    throw new Error(errorData.message || 'Verification failed');
                }

                setLoading(false);
                setError(null);

                setTimeout(() => {
                    navigate('/login');
                }, 4000);
            } catch (err) {
                setLoading(false);
                setError(err.message || 'Something went wrong');
            }
        };

        if (token) {
            verifyEmail();
        } else {
            setLoading(false);
            setError('Missing token in URL');
        }
    }, [token, navigate]);

    return (
        <div className="verify-email-container">
            {loading ? (
                <p>Verifying your email...</p>
            ) : error ? (
                <p className="error-message">Verification failed: {error}</p>
            ) : (
                <p style={{ color: "#28a745" }}>Verification of user email complete, navigating to the login screen.</p>
            )}
        </div>
    );
};

export default VerifyEmail;